/**
 * 未認証でも閲覧できるパス
 *
 * 認証は useRedirectToLogin（App直下の副作用フック）が全ルート一律にかけるため、
 * 例外はここに列挙して同フックで除外する。
 *
 * /guide とその配下（系統別variant）: トラブルガイド。「ログインできない」区分を含む
 * 手順書であり、ログインを要求すると当の困っている店舗が到達できない。
 * 紙のシートのQR/URLからスマホで開く導線も想定している。
 *
 * 版は接頭辞でまとめて通す。版名を並べると pages/guide/routes.tsx と同じ表を
 * 2 つ持つことになり、版を足したときに片方だけ直して「ページは出るのに
 * ログインへ飛ぶ」が起きる。
 */
export const PUBLIC_PATHS: string[] = ['/guide']

/**
 * react-router の matching は末尾スラッシュを無視し、大文字小文字も区別しない
 * （@remix-run/router: `regexpSource += "\\/*$"` / `caseSensitive = false` が既定）。
 * useLocation().pathname は生の文字列を返すため、ここで同じ規則に揃えないと
 * `/guide/` や `/Guide` が「ページは描画されるのに認証で弾かれる」状態になる。
 * 紙のシートのURLを手打ちする導線がある以上、実際に起きる。
 */
const normalize = (pathname: string): string =>
  (pathname.replace(/\/+$/, '') || '/').toLowerCase()

export const isPublicPath = (pathname: string): boolean => {
  const path = normalize(pathname)
  return PUBLIC_PATHS.map(normalize).some(
    (publicPath) => path === publicPath || path.startsWith(`${publicPath}/`)
  )
}
